
export default {
  emits: ['submit'],

  props: {
    /**
     * Whether if the form is visible or not.
     */
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        fields: {
          email: '',
        },
      },
      loading: false,
    }
  },

  watch: {
    /**
     * Clear form and validation states when the form is no more visible.
     * @param {Boolean} val the dialog state.
     */
    visible(val) {
      if (!val && this.$refs.form) {
        this.$refs.form.reset()
      }
    },
  },

  methods: {
    /**
     * Form is valid, submit data.
     */
    async handleSubmit() {
      if (!this.loading) {
        await this.sendResetPassword()
        this.$emit('submit')
      }
    },

    /**
     * Send reset password request.
     */
    async sendResetPassword() {
      this.loading = true

      try {
        await this.$store.dispatch('authentication/sendResetPassword', {
          email: this.form.fields.email,
        })
      } catch (error) {
        // don't catch error about invalid user data, catch others
        const status = error.response?.status

        if (status !== 404) {
          this.$notify({
            message: this.$t('phrase.error_unknown'),
            type: 'error',
          })
          this.$sentry.captureException(error)
          return
        }
      } finally {
        this.loading = false
      }

      this.$notify({
        message: this.$t('notification.auth.password_reset_success'),
        type: 'success',
      })
    },
  },
}
